import { render, staticRenderFns } from "./OrdersInboundTable.vue?vue&type=template&id=7a9b23f0&scoped=true"
import script from "./OrdersInboundTable.vue?vue&type=script&lang=js"
export * from "./OrdersInboundTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersInboundTable.vue?vue&type=style&index=0&id=7a9b23f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9b23f0",
  null
  
)

export default component.exports